import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import { saveImageToDB, getImageFromDB, deleteImageFromDB } from '../utils/indexedDB';

export const duplicateImageAsync = createAsyncThunk(
  'customizer/duplicateImageAsync',
  async (id, { dispatch, getState }) => {
    const state = getState().customizer;
    const original = state.images.find((img) => img.id === id);
    if (!original) return;

    const newId = crypto.randomUUID();
    try {
      const imageBlob = await getImageFromDB('uploadedImages', id);
      if (imageBlob) {
        await saveImageToDB('uploadedImages', newId, imageBlob);
        dispatch(duplicateImage({
          ...original,
          id: newId,
          x: original.x + 40,
          y: original.y + 40,
        }));
      }
    } catch (error) { }
  }
);

export const removeImageAsync = createAsyncThunk(
  'customizer/removeImageAsync',
  async (id, { dispatch }) => {
    try {
      await deleteImageFromDB('uploadedImages', id);
      dispatch(removeImage(id));
    } catch (error) { }
  }
);

export const selectUploadedImageIds = createSelector(
  (state) => state.customizer.images,
  (images) => images.map((img) => img.id)
);

export const initialState = {
  frames: [
    {
      url: "/frames/artistic-frame-18.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "yellow, dog, cake, hearts",
      name: "artistic-frame-18"
    },
    {
      url: "/frames/artistic-frame-19.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "green, dog, cake, hearts",
      name: "artistic-frame-19"
    },
    {
      url: "/frames/artistic-frame-14.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "blue, celebration",
      name: "artistic-frame-14"
    },
    {
      url: "/frames/artistic-frame-15.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "orange, vintage, dog",
      name: "artistic-frame-15"
    },
    {
      url: "/frames/artistic-frame-16.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "blue, dog, cake, hearts",
      name: "artistic-frame-16"
    },
    {
      url: "/frames/artistic-frame-17.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "pink, dog, cake, hearts",
      name: "artistic-frame-17"
    },

    {
      url: "/frames/artistic-frame-20.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "green, leafs",
      name: "artistic-frame-20"
    },
    {
      url: "/frames/standard-frame-1.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "white",
      name: "standard-frame-1"
    },
    {
      url: "/frames/standard-frame-2.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "white",
      name: "standard-frame-2"
    },
    {
      url: "/frames/standard-frame-3.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "black",
      name: "standard-frame-3"
    },
    {
      url: "/frames/standard-frame-4.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "black",
      name: "standard-frame-4"
    },
    {
      url: "/frames/standard-frame-5.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "blue",
      name: "standard-frame-5"
    },
    {
      url: "/frames/standard-frame-6.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "blue",
      name: "standard-frame-6"
    },
    {
      url: "/frames/standard-frame-7.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "blue",
      name: "standard-frame-7"
    },
    {
      url: "/frames/standard-frame-8.png", category: "Standard", theme: "Dark", petNamePosition: "default",
      desc: "blue",
      name: "standard-frame-8"
    },
    {
      url: "/frames/standard-frame-9.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "pink, purple",
      name: "standard-frame-9"
    },
    {
      url: "/frames/standard-frame-10.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "pink, purple",
      name: "standard-frame-10"
    },
    {
      url: "/frames/standard-frame-11.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "beige",
      name: "standard-frame-11"
    },
    {
      url: "/frames/standard-frame-12.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "beige",
      name: "standard-frame-12"
    },
    {
      url: "/frames/standard-frame-13.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "red",
      name: "standard-frame-13"
    },
    {
      url: "/frames/standard-frame-14.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "red",
      name: "standard-frame-14"
    },
    {
      url: "/frames/artistic-frame-1.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "beige, white, dog",
      name: "artistic-frame-1"
    },
    {
      url: "/frames/artistic-frame-2.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "beige",
      name: "artistic-frame-2"
    },
    {
      url: "/frames/artistic-frame-3.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "blue, gradient, hearts",
      name: "artistic-frame-3"
    },
    {
      url: "/frames/artistic-frame-4.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "white, blue, gradient, hearts",
      name: "artistic-frame-4"
    },
    {
      url: "/frames/artistic-frame-5.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "beige, dog",
      name: "artistic-frame-5"
    },
    {
      url: "/frames/artistic-frame-6.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "blue, gradient, flowers",
      name: "artistic-frame-6"
    },
    {
      url: "/frames/artistic-frame-7.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "blue, gradient, bubbles",
      name: "artistic-frame-7"
    },
    {
      url: "/frames/artistic-frame-8.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "blue, gradient, flowers, hearts",
      name: "artistic-frame-8"
    },
    {
      url: "/frames/artistic-frame-9.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "white, hearts",
      name: "artistic-frame-9"
    },
    {
      url: "/frames/artistic-frame-10.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "white",
      name: "artistic-frame-10"
    },
    {
      url: "/frames/artistic-frame-11.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "beige",
      name: "artistic-frame-11"
    },
    {
      url: "/frames/artistic-frame-12.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "blue, gradient",
      name: "artistic-frame-12"
    },
    {
      url: "/frames/artistic-frame-13.png", category: "Standard", theme: "Light", petNamePosition: "default",
      desc: "white, dog",
      name: "artistic-frame-13"
    },



    {
      url: "/frames/holidays-frame-21.png", category: "Holidays", theme: "Dark", petNamePosition: "default",
      desc: "purple, holidays, halloween",
      name: "holidays-frame-21"
    },
    {
      url: "/frames/holidays-frame-22.png", category: "Holidays", theme: "Dark", petNamePosition: "default",
      desc: "blue, holidays, wolf, halloween",
      name: "holidays-frame-22"
    },
    {
      url: "/frames/holidays-frame-23.png", category: "Holidays", theme: "Light", petNamePosition: "default",
      desc: "orange, holidays, halloween",
      name: "holidays-frame-23"
    },
    {
      url: "/frames/holidays-frame-24.png", category: "Holidays", theme: "Dark", petNamePosition: "default",
      desc: "purple, holidays, halloween, dogs",
      name: "holidays-frame-24"
    },
    {
      url: "/frames/holidays-frame-25.png", category: "Holidays", theme: "Dark", petNamePosition: "default",
      desc: "blue, holidays, merry christmas",
      name: "holidays-frame-25"
    },
    {
      url: "/frames/holidays-frame-26.png", category: "Holidays", theme: "Dark", petNamePosition: "default",
      desc: "blue, holidays, merry christmas",
      name: "holidays-frame-25"
    },
    {
      url: "/frames/holidays-frame-27.png", category: "Holidays", theme: "Light", petNamePosition: "default",
      desc: "white, holidays, merry christmas",
      name: "holidays-frame-26"
    },
    {
      url: "/frames/holidays-frame-1.png", category: "Holidays", theme: "Dark", petNamePosition: "upper",
      desc: "green, christmas, happy new year",
      name: "holidays-frame-1"
    },
    {
      url: "/frames/holidays-frame-2.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "beige, christmas, happy new year",
      name: "holidays-frame-2"
    },
    {
      url: "/frames/holidays-frame-3.png", category: "Holidays", theme: "Dark", petNamePosition: "upper",
      desc: "green, christmas, happy new year",
      name: "holidays-frame-3"
    },
    {
      url: "/frames/holidays-frame-4.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "white, beige, butterflies, holidays, happy mother's day",
      name: "holidays-frame-4"
    },
    {
      url: "/frames/holidays-frame-5.png", category: "Holidays", theme: "Light", petNamePosition: "top",
      desc: "white, pink, flowers, holidays, happy mother's day",
      name: "holidays-frame-5"
    },
    {
      url: "/frames/holidays-frame-6.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "white, flowers, holidays, happy mother's day",
      name: "holidays-frame-6"
    },
    {
      url: "/frames/holidays-frame-7.png", category: "Holidays", theme: "Dark", petNamePosition: "default",
      desc: "blue, stars, holidays, happy fathers's day",
      name: "holidays-frame-7"
    },
    {
      url: "/frames/holidays-frame-8.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "white, blue, stars, holidays, happy fathers's day",
      name: "holidays-frame-8"
    },
    {
      url: "/frames/holidays-frame-9.png", category: "Holidays", theme: "Light", petNamePosition: "top",
      desc: "white, holidays, america, usa, remember and honor",
      name: "holidays-frame-9"
    },
    {
      url: "/frames/holidays-frame-10.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "white, holidays, america, usa, memorial day",
      name: "holidays-frame-10"
    },
    {
      url: "/frames/holidays-frame-11.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "white, red, holidays, america, usa, independence day",
      name: "holidays-frame-11"
    },
    {
      url: "/frames/holidays-frame-12.png", category: "Holidays", theme: "Light", petNamePosition: "top",
      desc: "white, holidays, balloons, america, usa, independence day",
      name: "holidays-frame-12"
    },
    {
      url: "/frames/holidays-frame-13.png", category: "Holidays", theme: "Dark", petNamePosition: "upper",
      desc: "blue, holidays, halloween",
      name: "holidays-frame-13"
    },
    {
      url: "/frames/holidays-frame-14.png", category: "Holidays", theme: "Dark", petNamePosition: "upper",
      desc: "purple, holidays, halloween",
      name: "holidays-frame-14"
    },
    {
      url: "/frames/holidays-frame-15.png", category: "Holidays", theme: "Light", petNamePosition: "top",
      desc: "beige, orange, flowers, holidays, thanksgiving",
      name: "holidays-frame-15"
    },
    {
      url: "/frames/holidays-frame-16.png", category: "Holidays", theme: "Light", petNamePosition: "top",
      desc: "beige, white, orange, flowers, holidays, thanksgiving",
      name: "holidays-frame-16"
    },
    {
      url: "/frames/holidays-frame-17.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "white, holidays, christmas",
      name: "holidays-frame-17"
    },
    {
      url: "/frames/holidays-frame-18.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "beige, holidays, christmas",
      name: "holidays-frame-18"
    },
    {
      url: "/frames/holidays-frame-19.png", category: "Holidays", theme: "Light", petNamePosition: "upper",
      desc: "white, blue, holidays, america, usa, veterans",
      name: "holidays-frame-19"
    },
    {
      url: "/frames/holidays-frame-20.png", category: "Holidays", theme: "Light", petNamePosition: "top",
      desc: "white, holidays, america, usa, labor day",
      name: "holidays-frame-20"
    },


    {
      url: "/frames/birthday-frame-8.png", category: "Birthdays", theme: "Light", petNamePosition: "default",
      desc: "pink, holidays, happy birthday",
      name: "birthday-frame-8"
    },
    {
      url: "/frames/birthday-frame-9.png", category: "Birthdays", theme: "Light", petNamePosition: "default",
      desc: "green, holidays, happy birthday",
      name: "birthday-frame-9"
    },
    {
      url: "/frames/birthday-frame-10.png", category: "Birthdays", theme: "Light", petNamePosition: "default",
      desc: "blue, holidays, happy birthday",
      name: "birthday-frame-10"
    },
    {
      url: "/frames/birthday-frame-11.png", category: "Birthdays", theme: "Light", petNamePosition: "top",
      desc: "white, holidays, happy birthday",
      name: "birthday-frame-11"
    },
    {
      url: "/frames/birthday-frame-12.png", category: "Birthdays", theme: "Light", petNamePosition: "default",
      desc: "blue, holidays, happy birthday",
      name: "birthday-frame-12"
    },
    {
      url: "/frames/birthday-frame-1.png", category: "Birthdays", theme: "Light", petNamePosition: "default",
      desc: "white, blue, hearts, holidays, happy birthday",
      name: "birthday-frame-1"
    },
    {
      url: "/frames/birthday-frame-2.png", category: "Birthdays", theme: "Light", petNamePosition: "default",
      desc: "white, balloons, holidays, happy birthday",
      name: "birthday-frame-2"
    },
    {
      url: "/frames/birthday-frame-3.png", category: "Birthdays", theme: "Light", petNamePosition: "upper",
      desc: "white, holidays, happy birthday",
      name: "birthday-frame-3"
    },
    {
      url: "/frames/birthday-frame-4.png", category: "Birthdays", theme: "Light", petNamePosition: "upper",
      desc: "blue, gradient, holidays, happy birthday",
      name: "birthday-frame-4"
    },
    {
      url: "/frames/birthday-frame-5.png", category: "Birthdays", theme: "Light", petNamePosition: "default",
      desc: "white, beige, hearts, holidays, happy birthday",
      name: "birthday-frame-5"
    },
    {
      url: "/frames/birthday-frame-6.png", category: "Birthdays", theme: "Light", petNamePosition: "bottom",
      desc: "beige, cake, holidays, happy birthday",
      name: "birthday-frame-6"
    },
    {
      url: "/frames/birthday-frame-7.png", category: "Birthdays", theme: "Light", petNamePosition: "upper",
      desc: "beige, balloons, holidays, happy birthday",
      name: "birthday-frame-7"
    },



    {
      url: "/frames/occasions-frame-17.png", category: "Occasions", theme: "Dark", petNamePosition: "upper",
      desc: "blue, holidays, happy gotcha day",
      name: "occasions-frame-17"
    },
    {
      url: "/frames/occasions-frame-18.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "beige, holidays, happy gotcha day",
      name: "occasions-frame-18"
    },
    {
      url: "/frames/occasions-frame-19.png", category: "Occasions", theme: "Dark", petNamePosition: "default",
      desc: "pink, holidays, happy gotcha day",
      name: "occasions-frame-19"
    },
    {
      url: "/frames/occasions-frame-20.png", category: "Occasions", theme: "Dark", petNamePosition: "default",
      desc: "green, holidays, happy gotcha day",
      name: "occasions-frame-20"
    },
    {
      url: "/frames/occasions-frame-21.png", category: "Occasions", theme: "Dark", petNamePosition: "default",
      desc: "blue, holidays, happy gotcha day",
      name: "occasions-frame-21"
    },
    {
      url: "/frames/occasions-frame-1.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "beige, hearts, flowers, love, occasions",
      name: "occasions-frame-1"
    },
    {
      url: "/frames/occasions-frame-2.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "beige, flowers, love, occasions",
      name: "occasions-frame-2"
    },
    {
      url: "/frames/occasions-frame-3.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "white, blue, hearts, love, occasions",
      name: "occasions-frame-3"
    },
    {
      url: "/frames/occasions-frame-4.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "pink, hearts, love, occasions",
      name: "occasions-frame-4"
    },
    {
      url: "/frames/occasions-frame-5.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "white, blue, love, occasions",
      name: "occasions-frame-5"
    },
    {
      url: "/frames/occasions-frame-6.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "white, purple, flowers, occasions",
      name: "occasions-frame-6"
    },
    {
      url: "/frames/occasions-frame-7.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "beige, flowers, occasions",
      name: "occasions-frame-7"
    },
    {
      url: "/frames/occasions-frame-8.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "white, blue, dog, occasions",
      name: "occasions-frame-8"
    },
    {
      url: "/frames/occasions-frame-9.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "blue, hearts, flowers, occasions",
      name: "occasions-frame-9"
    },
    {
      url: "/frames/occasions-frame-10.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "white, blue, hearts, occasions",
      name: "occasions-frame-10"
    },
    {
      url: "/frames/occasions-frame-11.png", category: "Occasions", theme: "Light", petNamePosition: "top",
      desc: "white, blue, dog, occasions",
      name: "occasions-frame-11"
    },
    {
      url: "/frames/occasions-frame-12.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "white, balloons, occasions",
      name: "occasions-frame-12"
    },
    {
      url: "/frames/occasions-frame-13.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "white, purple, balloons, hearts, love, occasions",
      name: "occasions-frame-13"
    },
    {
      url: "/frames/occasions-frame-14.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "beige, hearts, love, occasions",
      name: "occasions-frame-14"
    },
    {
      url: "/frames/occasions-frame-15.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "beige, pink, hearts, love, occasions",
      name: "occasions-frame-15"
    },
    {
      url: "/frames/occasions-frame-16.png", category: "Occasions", theme: "Light", petNamePosition: "upper",
      desc: "beige, hearts, flowers, occasions",
      name: "occasions-frame-16"
    },
    {
      url: "/frames/campaigns/ilmd-frame.png", category: "Occasions", theme: "Dark", petNamePosition: "upper",
      desc: "blue, dog, occasions",
      name: "ilmd"
    },

  ],
  framesCategories: ["Standard", "Holidays", "Birthdays", "Occasions"],
  framesModalCategories: ["All", "Standard", "Holidays", "Birthdays", "Occasions"],
  petNamePositions: ["bottom", "default", "upper", "top"],
  selectedFrame: {
    url: "/frames/artistic-frame-18.png", category: "Standard", theme: "Light", petNamePosition: "default",
    desc: "yellow, dog, cake, hearts",
    name: "artistic-frame-18"
  },
  selectedFrameCategory: "Standard",
  selectedFrameModalCategory: "All",
  selectedImageId: null,
  images: [],
  includePetName: false,
  petName: '',
  petType: null,
  petTypes: ['dog', 'cat', 'horse'],
  customizerStep: 1,
  customizedProduct: null,
};

const customizerSlice = createSlice({
  name: 'customizer',
  initialState,
  reducers: {
    setCustomizedProduct: (state, action) => {
      state.customizedProduct = {
        product: action.payload.product,
        isSubscribed: action.payload.isSubscribed,
        quantity: action.payload.quantity,
      };
    },
    resetCustomizedProduct: (state) => {
      state.customizedProduct = null;
    },
    setCustomizerStep: (state, action) => {
      state.customizerStep = action.payload;
    },
    changeCustomizerStep: (state, action) => {
      state.customizerStep = Math.max(1, state.customizerStep + action.payload);
    },
    setSelectedFrame: (state, action) => {
      state.selectedFrame = action.payload;
    },
    setSelectedFrameCategory: (state, action) => {
      state.selectedFrameCategory = action.payload;
    },
    setSelectedFrameModalCategory: (state, action) => {
      state.selectedFrameModalCategory = action.payload;
    },
    addNewImage: (state, action) => {
      const { id, ...metadata } = action.payload;
      state.images.push({ id, ...metadata });
    },
    removeImage: (state, action) => {
      state.images = state.images.filter((img) => img.id !== action.payload);
    },
    moveImage: (state, action) => {
      const { id, x, y } = action.payload;
      const image = state.images.find(img => img.id === id);
      if (image) {
        image.x = x;
        image.y = y;
      }
    },
    rotateImage: (state, action) => {
      const { id, angle } = action.payload;
      const image = state.images.find(img => img.id === id);
      if (image) {
        image.rotation += angle;
      }
    },
    scaleImage: (state, action) => {
      const { id, scale } = action.payload;
      const image = state.images.find(img => img.id === id);
      if (image) {
        image.scale = scale;
      }
    },
    duplicateImage: (state, action) => {
      state.images.push(action.payload);
    },
    setIncludePetName: (state, action) => {
      state.includePetName = action.payload;
      state.petName = '';
    },
    setPetName: (state, action) => {
      state.petName = action.payload;
    },
    setPetType: (state, action) => {
      state.petType = action.payload;
    },
    resetCustomizer: (state) => {
      state.selectedFrame = {
        url: "/frames/artistic-frame-18.png", category: "Standard", theme: "Light", petNamePosition: "default",
        desc: "yellow, dog, cake, hearts",
        name: "artistic-frame-18"
      };
      state.selectedImageId = null;
      state.images = [];
      state.includePetName = false;
      state.petName = '';
      state.petType = null;
      state.selectedFrameCategory = "Standard";
      state.selectedFrameModalCategory = "All";
    }
  },
});

export const {
  setCustomizerStep,
  changeCustomizerStep,
  setSelectedFrame,
  setSelectedFrameCategory,
  setSelectedFrameModalCategory,
  addNewImage,
  removeImage,
  moveImage,
  rotateImage,
  scaleImage,
  duplicateImage,
  resetCustomizer,
  setIncludePetName,
  setPetName,
  setPetType,
  setCustomizedProduct,
  resetCustomizedProduct
} = customizerSlice.actions;

export default customizerSlice.reducer;
export { initialState as customizerInitialState };
